<div class="col-sm-12 col-md-6 col-lg-4 py-5 contact-home-info">
   <ul class="list-unstyled">
      <li class="media mb-5">
         <div class="d-flex mr-4"><i class="ion-ios-pin font-3x text-warning"></i></div>
         <div class="media-body">
            <h5 class="mb-3"> Dove siamo </h5>
            <span>{{contact?.location}}</span>
         </div>
      </li>
   </ul>
</div>
<div class="col-sm-12 col-md-6 col-lg-4 py-5 contact-home-info">
   <ul class="list-unstyled">
      <li class="media">
         <div class="d-flex mr-4"><i class="ion-ios-chatboxes font-3x text-warning"></i></div>
         <div class="media-body">
            <h5 class="mb-3"> Contatti </h5>
            <span *ngFor="let email of contact?.email">
               <span *ngIf="email?.status == 1">
                  <a href="mailto:{{email?.value}}" class="d-block mb-1 text-dark">{{email?.value}}</a>
               </span>
            </span>
            <span *ngFor="let phone of contact?.phone">
               <span *ngIf="phone?.status == 1">
                  <a href="tel:{{phone?.value}}" class="d-block mb-1 text-dark">{{phone?.value}}</a>
               </span>
            </span>
            <span *ngFor = "let hours of contact?.business_hours">
               <span *ngIf="hours?.status == 1">
                  {{hours?.value}}
               </span>
            </span>
         </div>
      </li>
   </ul>
</div>
<div class="col-sm-12 col-md-6 col-lg-4 py-5 contact-home-info">
   <ul class="list-unstyled">
      <li class="media">
         <div class="d-flex mr-4"><i class="ion-ios-share font-3x text-warning"></i></div>
         <div class="media-body">
            <h5 class="mb-3"> Social </h5>
            <i class="fab fa-facebook-square font-2x px-1"></i>
            <i class="fab fa-instagram font-2x  px-1"></i>
            <i class="fab fa-linkedin font-2x  px-1"></i>
         </div>
      </li>
   </ul>
</div>
<!--<div class="col-sm-12 col-md-6 col-lg-8">
   <div class="card card-height-100">
      <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Dove siamo</h4>
          <div class="flex-shrink-0">

          </div>
      </div>


      <div class="card-body">
         <div style="height: 300px;"
         leaflet  
         [leafletOptions]="options">
    </div>
      </div>

  </div>
</div>
-->